import Section from '../ui/Section'
import { Display, Body, Points, Accent } from '../ui/Type'

const RUN = ['More agents.', 'Longer reasoning.', 'More analysis.', 'Larger workloads.', 'More frequent execution.']

export default function UnlimitedTokens() {
  return (
    <Section id="unlimited-tokens" label="Unlimited tokens">
      <Display>
        <Accent>Unlimited context</Accent> changes what becomes possible.
      </Display>

      <Body className="mt-8">
        When every additional reasoning step creates another marginal API charge, successful AI adoption can become its
        own economic constraint.
      </Body>
      <Body className="mt-5">LiquidBrain changes that relationship. Run:</Body>
      <Points className="mt-8" cols={2} items={RUN} />
      <Body className="mt-8">without designing every workflow around a token meter.</Body>

      <div className="mt-14 grid grid-cols-1 gap-x-12 gap-y-8 sm:grid-cols-2">
        <div>
          <div className="font-mono text-[11.5px] tracking-[0.14em] text-[var(--faint)] uppercase">Don't ask</div>
          <p className="mt-4 text-[clamp(1.15rem,2vw,1.4rem)] leading-[1.35] tracking-[-0.02em] text-[var(--muted)]">
            &ldquo;How many tokens can we afford?&rdquo;
          </p>
        </div>
        <div>
          <div className="font-mono text-[11.5px] tracking-[0.14em] text-[var(--ink-blue)] uppercase">Ask</div>
          <p className="mt-4 text-[clamp(1.15rem,2vw,1.4rem)] leading-[1.35] tracking-[-0.02em] text-[var(--ink)]">
            What does the workload need to accomplish?
          </p>
        </div>
      </div>
    </Section>
  )
}
